<template>
  <div
    class="modal"
    :id="id"
    v-if="visible"
  >
    <div
      class="modal__header"
      :class="[headlineType ? `modal__header--${headlineType}` : '']"
      v-if="headline"
      v-html="headline"
    />
    <span
      class="modal__close-button"
      @click="close"
      :aria-label="$t('global.modal.close.button.aria.label')"
      role="button"
      tabindex="0"
      @keydown="handleKeyDown"
    />
    <div class="modal__content">
      <slot />
    </div>
  </div>
</template>

<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';

  export default {
    mixins: [
      globalStateComputedMixin
    ],
    props: {
      id: String,
      headline: String,
      headlineType: String,
      initialVisible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible: this.initialVisible
      };
    },
    created() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'showModal') {
          this.subscribeModalOpenHandler(mutation.payload)
          document.body.classList.add('modal-open')
        }

        if (mutation.type === 'hideModal') {
          this.subscribeModalCloseHandler(mutation.payload)
          document.body.classList.remove('modal-open')
        }
      });
    },
    methods: {
      subscribeModalOpenHandler(data) {
        if (data.id === this.id) {
          this.visible = true;
        }
      },
      subscribeModalCloseHandler(data) {
        if (data.id === this.id) {
          this.visible = false;
        }
      },
      open() {
        this.$store.dispatch('showModal', { id: this.id })
      },
      close() {
        this.$store.dispatch('hideModal', { id: this.id })
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    }
  };

</script>
